import { createStore } from 'vuex'
import http from '../utils/http.js'

export default createStore({
  state: {
    // 春节配置时间
    newYearConfig: null,
    // 是否已经请求过接口
    newYearConfigLoaded: false,
    // 应用初始化状态
    appInitialized: false
  },
  getters: {
    // 获取春节配置
    getNewYearConfig: (state) => state.newYearConfig,
    // 检查是否在春节期间
    isInNewYearPeriod: (state) => {
      if (!state.newYearConfig) return false
      const now = new Date()
      now.setHours(0, 0, 0, 0)
      const start = new Date(state.newYearConfig.startDate)
      const end = new Date(state.newYearConfig.endDate)
      start.setHours(0, 0, 0, 0)
      end.setHours(0, 0, 0, 0)
      return now >= start && now <= end
    },
    // 应用是否已初始化
    isAppInitialized: (state) => state.appInitialized
  },
  mutations: {
    setNewYearConfig(state, config) {
      state.newYearConfig = config
      state.newYearConfigLoaded = true
    },
    setNewYearConfigLoaded(state, loaded) {
      state.newYearConfigLoaded = loaded
    },
    setAppInitialized(state, initialized) {
      state.appInitialized = initialized
    }
  },
  actions: {
    // 获取春节配置（只请求一次）
    async fetchNewYearConfig({ commit, state }) {
      // 如果已经加载过，直接返回
      if (state.newYearConfigLoaded && state.newYearConfig) {
        return state.newYearConfig
      }
      
      try {
        const config = await http.getNewYearConfig()
        if (config) {
          commit('setNewYearConfig', config)
        } else {
          commit('setNewYearConfigLoaded', true)
        }
        return config
      } catch (error) {
        console.error('获取春节配置失败:', error)
        commit('setNewYearConfigLoaded', true)
        return null
      }
    }
  },
  modules: {
  }
})
